import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../AuthContext';
import { User, Lock, Eye, EyeOff } from 'lucide-react';
import styles from './Login.module.css';

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [waitingForOtp, setWaitingForOtp] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const { loginUser, loading, error, otpRequired, authTokens } = useContext(AuthContext);

    useEffect(() => {
        return () => { setUsername(''); setPassword(''); setWaitingForOtp(false); };
    }, []);

    useEffect(() => {
        if (authTokens && !otpRequired) {
            window.location.href = '/';
        }
    }, [authTokens, otpRequired]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!username.trim() || !password.trim()) return;
        try {
            setWaitingForOtp(false);
            const success = await loginUser(username, password);
            if (success && !otpRequired) {
                setIsSuccess(true);
            } else if (success && otpRequired) {
                setWaitingForOtp(true);
            }
        } catch (err) {
            console.error('Ошибка входа:', err);
        }
    };

    return (
        <div className={styles.loginContainer}>
            <div className={styles.loginBox}>

                <div className={styles.logoSection}>
                    <div className={styles.logoContainer}>
                        <img src="/logo.png" alt="CONNEXTA SYSTEM" className={styles.logoImage} />
                    </div>
                </div>

                {error && (
                    <div className={styles.alert}>{error}</div>
                )}

                {waitingForOtp ? (
                    <div style={{ textAlign: 'center', padding: '1.5rem 0' }}>
                        <div className={styles.loadingSpinner} style={{ margin: '0 auto 1rem' }} />
                        <p className={styles.bodyText} style={{ fontWeight: 600 }}>
                            Отправляем код...
                        </p>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className={styles.loginForm}>
                        <div className={styles.formGroup}>
                            <label htmlFor="lp-username" className={styles.label}>
                                Имя пользователя
                            </label>
                            <div className={styles.inputWrapper}>
                                <User className={styles.inputIcon} />
                                <input
                                    id="lp-username"
                                    type="text"
                                    value={username}
                                    onChange={e => setUsername(e.target.value)}
                                    className={styles.input}
                                    placeholder="Введите имя пользователя"
                                    required
                                    autoComplete="username"
                                    disabled={loading || isSuccess}
                                />
                            </div>
                        </div>

                        <div className={styles.formGroup}>
                            <label htmlFor="lp-password" className={styles.label}>
                                Пароль
                            </label>
                            <div className={styles.inputWrapper}>
                                <Lock className={styles.inputIcon} />
                                <input
                                    id="lp-password"
                                    type={showPassword ? 'text' : 'password'}
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    className={styles.input}
                                    placeholder="Введите пароль"
                                    required
                                    autoComplete="current-password"
                                    disabled={loading || isSuccess}
                                />
                                <button
                                    type="button"
                                    className={styles.passwordToggle}
                                    onClick={() => setShowPassword(v => !v)}
                                >
                                    {showPassword
                                        ? <EyeOff className={styles.toggleIcon} />
                                        : <Eye className={styles.toggleIcon} />
                                    }
                                </button>
                            </div>
                        </div>

                        <button
                            type="submit"
                            className={[
                                styles.loginButton,
                                loading ? styles.loading : '',
                                isSuccess ? styles.success : '',
                            ].join(' ')}
                            disabled={loading || isSuccess || !username.trim() || !password.trim()}
                        >
                            {isSuccess ? (
                                <div className={styles.successIcon}>
                                    <div className={styles.checkmarkCircle}>
                                        <span className={styles.checkmark}>&#10003;</span>
                                    </div>
                                </div>
                            ) : loading ? (
                                <div className={styles.loadingSpinner} />
                            ) : (
                                'Войти'
                            )}
                        </button>
                    </form>
                )}

            </div>
        </div>
    );
};

export default LoginPage;
